import helperService from "../services/helper.service";
import moment from "moment";

export const csvSchema = [
	{
		label: "Client Name",
		key: "clientName",
		formatter: (v) => v,
	},
	{
		label: "Amount (₦)",
		key: "amount",
		formatter: (v) => helperService.handleMoneyFormat(v, 2, true, "NGN"),
	},
	{
		label: "Start Date",
		key: "createdAt",
		formatter: (v) => moment(v).format("MMM DD, YYYY"),
	},
	{
		label: "Next Due Date",
		key: "nextDueDate",
		formatter: (v) => moment(v).format("MMM DD, YYYY"),
	},
	{
		label: "Frequency",
		key: "frequency",
		formatter: (v) => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase(),
	},
	{
		label: "Cycles",
		key: "cycle",
		formatter: (v) => v,
	},
	{
		label: "Status",
		key: "status",
		formatter: (v) => helperService.capitalize(v),
	},
	{
		label: "Notified Teams",
		key: "notifyTeams",
		formatter: (arr) => (Array.isArray(arr) ? arr.join(", ") : ""),
	},
	{
		label: "Additional Notes",
		key: "additionalNotes",
		formatter: (v) => v,
	},
];
